// extracted by mini-css-extract-plugin
module.exports = {"disable-scroll":"staticToast_disable-scroll__1IrfP"};